import CachedInstance from "../cache/CachedInstance";
import GridTile from "../grid/GridTile";
import Color from "../color/Color"

export default class LightSource extends CachedInstance {
    constructor() {        
        super();

        /**
         * @type {Color}
         */
        this.color = null;
        /**
         * @type {number}
         */
        this.radius = 0;
        /**
         * @type {GridTile}
         */
        this.tile = null;
    }

    /**
     * @param {GridTile} tile
     * @param {Color} color 
     * @param {number} radius 
     */
    set(tile, color, radius) {
        this.tile = tile;
        this.color = color;
        this.radius = radius;
    }

    /**
     * @returns {GridTile}
     */
    getTile() {
        return this.tile;
    }
    
    /**
     * @param {GridTile} tile 
     */
    setTile(tile) {
        this.tile = tile;
    }

    /**
     * @returns {Color}
     */
    getColor() {
        return this.color;
    }

    /**
     * @returns {number}
     */
    getTileRadius() {
        return this.radius;
    }

    /////////////////////////////////////////////
    // CachedInstance
    /////////////////////////////////////////////

    /**
     * @param {boolean} finishedAndAvailable 
     */
    reset(finishedAndAvailable) {
        super.reset(finishedAndAvailable);
        this.color = null;
        this.radius = 0;
        this.tile = null;
    }
}